import React from 'react';
import './TipsComponent.scss';
import {getRandom, getSessionCache, isInWeChat} from "../../asstes/js/Utils";
import dayjs from 'dayjs'
import {openReward} from "../../asstes/js/Rescource";
import {analysisSubmit, showToast} from "../../asstes/js/IntegratedProcessing";

class TipsComponent extends React.Component {
	state = {
		initImg: false,
		titleImgInit: false,
		getRandomIdx: getSessionCache('selectMouse') || getRandom(0, 5), // || getRandom(0, 5)
	}

	btnClick = (e) => {
		e.preventDefault()
		let {methods, config} = this.props
		if (config && config.name === 'receiveShareReward') { // 领取分享的
			this.openReward(config.data) // 点击去开奖
			return;
		}
		if (methods) {
			let {vm, name, needClose} = methods
			if (name === 'linkFollow') {
				window.location.href = methods.url
				return;
			}
			vm[name]()
			if (!needClose) {
				return
			}
		}
		this.close()
	}

	close = () => {
		this.props.close && this.props.close.onClose()
	}

	initImg = () => {
		this.setState({
			initImg: true
		})
	}

	titleImgInit = () => {
		this.setState({
			titleImgInit: true
		})
	}

	openReward = async (data) => {
		if (!isInWeChat()) {
			showToast('请分享到微信领取')
			return
		}
		for (let item of data) {
			// await (console.log(item.sendNo))
			await openReward({sendNo: item.sendNo})
		}
		showToast('领取成功！')
		analysisSubmit('openPrize')
		// getTypeData
		let {config} = this.props
		if (config) {
			let {vm} = config
			if (vm['getTypeData']) {
				vm['getTypeData']('reload')
			}
		}
		this.close()
	}

	render() {
		const loginBg = require('../../asstes/img/alert/login.png')
		const payTop = require('../../asstes/img/alert/pay-top.png')
		// const successTop = require('../../asstes/img/alert/pay-top-success.png')
		const fire = require('../../asstes/img/reveive/fire.gif')
		const PayClose = require('../../asstes/img/alert/login-close.png')
		const btnBg = require('../../asstes/img/alert/btn-bg.png')
		const {text, btnText, config} = this.props
		const {initImg, titleImgInit, getRandomIdx} = this.state
		const isShowTitle = text.includes('不含深圳')
		const topImg = config && config.topImg ? {
			marginTop: config.topImg
		} : {}
		const successTopArr = [
			require('../../asstes/img/alert/pay-top-success/pay-top-success1.png'),
			require('../../asstes/img/alert/pay-top-success/pay-top-success2.png'),
			require('../../asstes/img/alert/pay-top-success/pay-top-success3.png'),
			require('../../asstes/img/alert/pay-top-success/pay-top-success4.png'),
			require('../../asstes/img/alert/pay-top-success/pay-top-success5.png'),
			require('../../asstes/img/alert/pay-top-success/pay-top-success6.png'),
		]

		function changeTime(item) {
			if (item.updateTime) {
				return (item.updateTime).slice(5, 10)
			} else if (item.createTimeStamp) {
				return dayjs(item.createTimeStamp).format('MM-DD')
			} else {
				return '---'
			}
		}

		return <div className="tips-container">
			<p className="prompt"></p>
			<div className="tips-relative">
				<img src={loginBg} onLoad={this.initImg} alt=""/>
				{
					initImg ?
						<>
							<div className="tip-content flex-center-center">
								{
									config && config.showFire ?
										<>
											<img className="fire-gif" src={fire} alt=""/>
											<img className="tips-top-img success-tips-top-img" onLoad={this.titleImgInit} src={successTopArr[getRandomIdx]} alt=""/>
										</> :
										<img className={`tips-top-img ${isShowTitle? '' : 'big-img'}`} style={topImg} onLoad={this.titleImgInit} src={payTop} alt=""/>
								}
								{
									titleImgInit ?
										<>
											{
												isShowTitle ? <p className="tips-context-title">
													Sorry~ 您不是本次活动受邀客户哦~
												</p> : null
											}
											<p className={`tips-context ${isShowTitle ? 'top-near' : ''}`} dangerouslySetInnerHTML={{__html: text}}>
												{/* 活动受邀用户支付1分钱还有惊喜大奖，赶紧输入预留手机验证吧！ */}
											</p>
											{
												!(config && config.name === 'receiveShareReward') ? null :
													<div className="show-reward-list">
														{
															config.data.map((item, idx) => {
																return <p className="flex-center-center" key={idx}>
																	<span>{changeTime(item)}</span>
																	<span className="ml-30">{(item.rcombiName)}</span>
																</p>
															})
														}
													</div>
											}
											<a href={'/'} onClick={this.btnClick}>
												<div className="tips-btn-font">
													<img src={btnBg} alt=""/>
													<p className="tips-btn-text flex-center-center">
														{btnText || '我知道了'}
													</p>
												</div>
											</a>
										</> : null
								}
							</div>
							<div className={`login-close flex-center-center ${(config && (config.name === 'showReceiveShareReward' || config.name === 'receiveShareReward')) ? 'order-login-close' : ''}`}>
								<img className="login-close-icon" src={PayClose} alt="" onClick={this.close}/>
							</div>
						</> : null
				}
			</div>
		</div>
	}
}

export default TipsComponent;
